import { FeedbackInfoColorToken, TInfo } from './info.palette'
import { FeedbackNegativeColorToken, TNegative } from './negative.palette'
import { NeutralColorToken, TNeutral } from './neutral.pallette'
import { FeedbackPositiveColorToken, TPositive } from './positive.palette'
import { BrandPrimaryColorToken, TPrimary } from './primary.palette'
import { BrandSecondaryColorToken, TSecondary } from './secondary.palette'
import { FeedbackWarningColorToken, TWarning } from './warning.palette'

export default {
  ...BrandPrimaryColorToken,
  ...BrandSecondaryColorToken,
  ...FeedbackNegativeColorToken,
  ...FeedbackInfoColorToken,
  ...NeutralColorToken,
  ...FeedbackPositiveColorToken,
  ...FeedbackWarningColorToken,
}

export type TColor =
  | TPrimary
  | TSecondary
  | TNegative
  | TInfo
  | TNeutral
  | TPositive
  | TWarning
